import { useEffect } from "react";
import { useHistory } from "react-router-dom";

/**
 * Custom hook to manage navigation within crew members context
 * Preserves table state (search, pagination) when navigating within crew members
 * and clears state when navigating to other sections
 */
export const useCrewMembersNavigation = () => {
  const history = useHistory();

  useEffect(() => {
    // Listen for navigation away from this section
    const unlisten = history.listen((location) => {
      // Only preserve flags if staying within crew members context or going back to crew members list
      const isLeavingToCrewMembers = location.pathname.match(/\/crew\/\d+\/members$/) !== null;
      const isStayingInCrewMembersContext = location.pathname.match(/\/crew\/\d+\/members\/\d+\//) !== null;

      if (!isLeavingToCrewMembers && !isStayingInCrewMembersContext) {
        sessionStorage.removeItem("table./crew/:crewId/members.forwardNav");
      }
    });

    return () => unlisten();
  }, [history]);

  const handleGoBack = () => {
    // Don't clear flags when going back - let TableComponent restore state
  };

  return { handleGoBack };
};
